<template lang="pug">
  nav.navbar.is-fixed-top(:class="classNavBar" role='navigation' aria-label='main navigation')
    .container
      .navbar-brand
        a.navbar-item(to="/")
          img#logoBrand(v-if="classNavBar === 'is-white'" src='@/assets/ducter_color.png')
          img#logoBrand(v-else src='@/assets/ducter_Blanco.png')
        a#navBurger.navbar-burger.burger(role='button' aria-label='menu' aria-expanded='false' data-target='navbarMenu' @click="displayBurger")
          span(:class="classNavBar ==='is-white'? 'has-text-dark' : 'has-text-white'" aria-hidden='true')
          span(:class="classNavBar ==='is-white'? 'has-text-dark' : 'has-text-white'" aria-hidden='true')
          span(:class="classNavBar ==='is-white'? 'has-text-dark' : 'has-text-white'" aria-hidden='true')
      #navbarMenu.navbar-menu
        .navbar-end
</template>

<script>
export default {
  name: "NavBar",
  props: ['classNavBar'],
  methods: {
    displayBurger() {
      let burger = document.getElementById("navBurger");
      let nav = document.getElementById(burger.dataset.target);
      burger.classList.toggle("is-active");
      nav.classList.toggle("is-active");
    },
    verModal() {
      this.$emit('verModal', true)
    },
    irSeccion(section) {
      this.$emit('irSeccion', section)
    },
  }
};
</script>

<style scoped>
#logoBrand {
  max-width: 150px;
}

.navbar-item img {
  max-height: 100%;
}

.navbar {
  height: 80px;
}

.is-white {
  background-color: white;
}
.is-transparent {
  background-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/components/landing_Componentes/NavBar.vue